import { render, staticRenderFns } from "./warehouse-management-approval.vue?vue&type=template&id=1400870c"
import script from "./warehouse-management-approval.vue?vue&type=script&lang=ts"
export * from "./warehouse-management-approval.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports